import { Component } from 'react';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="fatal-error" id="main-content">
        <p className="page-intro__eyebrow">BlockScan recovery</p>
        <h1>Something interrupted this view.</h1>
        <p>Your search and saved wallets are still safe in this browser.</p>
        <button type="button" onClick={() => window.location.reload()}>Reload BlockScan</button>
      </main>
    );
  }
}

export default AppErrorBoundary;
